import React from 'react';

import { Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { Job } from '@libs/graphql-types';

import { JobAccordion } from './JobAccordion';

const useStyles = makeStyles((theme: any) => ({
  label: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
    marginBottom: theme.spacing(0.5),
  },
  value: {
    fontSize: '0.875rem',
    fontWeight: 500,
  },
}));

interface JobLocationAccordionProps {
  jobData: Job;
  expanded?: boolean;
  onChange?: (expanded: boolean) => void;
}

export const JobLocationAccordion: React.FC<JobLocationAccordionProps> = ({
  jobData,
  expanded,
  onChange,
}) => {
  const classes = useStyles();

  // Extract location data from job object
  const striiveJob = jobData.striive_job;
  const locationData = {
    workSiteAddress: striiveJob?.work_site_address || 'N/A',
    workSiteCity: striiveJob?.work_site_city || 'N/A',
    workSiteStateCode: striiveJob?.work_site_state_code || 'N/A',
    postalZipCode: striiveJob?.work_site_postal_code || 'N/A',
    additionalWorkSiteAddress: striiveJob?.work_site_address2 || 'N/A',
    workSiteId: striiveJob?.work_site_record_id || 'N/A',
    workSiteCountryCode: striiveJob?.work_site_country_code || 'N/A',
  };

  const renderDetailItem = (label: string, value: string | number) => (
    <Grid item xs={12} sm={6}>
      <Typography className={classes.label}>{label}</Typography>
      <Typography className={classes.value}>{value}</Typography>
    </Grid>
  );

  return (
    <JobAccordion title="JOB LOCATION" expanded={expanded} onChange={onChange}>
      <Grid container spacing={3}>
        {renderDetailItem('Work Site Address:', locationData.workSiteAddress)}
        {renderDetailItem(
          'Additional Work Site Address:',
          locationData.additionalWorkSiteAddress,
        )}
        {renderDetailItem('Work Site City:', locationData.workSiteCity)}
        {renderDetailItem('Work Site ID:', locationData.workSiteId)}
        {renderDetailItem(
          'Work Site State Code:',
          locationData.workSiteStateCode,
        )}
        {renderDetailItem(
          'Work Site Country Code:',
          locationData.workSiteCountryCode,
        )}
        {renderDetailItem('Postal/Zip Code:', locationData.postalZipCode)}
      </Grid>
    </JobAccordion>
  );
};
